import { Link } from "react-router-dom";

export default function BlogListItem2( { item, index, headings, length } ){

    let title = item.properties.Name?.title[0]?.plain_text;
    let summary = item.properties.Summary?.rich_text?.[0]?.plain_text;
    let date = item.properties.Date.formula.string;
    let days = item.properties.Days.formula.string;
    let tags = item.properties.Tags.multi_select;
    let category = item.properties.Category.multi_select;
    let link = item.properties.Link?.rich_text?.[0]?.plain_text;

    let created = item.properties.Created_date.formula.string;
    let edited = item.properties.Edited_date.formula.string;

    let thumbnail = item.icon?.file?.url || null;

    // Convert headings array to a string joined by '/'
    let headingsString = '';
    if (headings && headings.length > 0) {
        headingsString = headings
            .map(heading => {
                const richTextArr = heading[heading.type]?.rich_text;
                return (richTextArr && richTextArr.length > 0) ? richTextArr[0].plain_text : '';
            })
            .filter(Boolean)
            .join(' / ');
    }

    return(
        <Link className = "a" to = {`/blog/${item.id}`} state = { { title : title, summary : summary, date : date, tags : tags, created : created, edited : edited, category : category, days : days, link : link } } style = { { textDecoration : "none" } }>
            <div style = { { borderTop: "1px solid var(--black8)", display : "flex", width : "100%", padding : 0, margin : 0, alignItems : "flex-start", paddingTop : "16px" } }>
                <h3 style = { { width : "100px", fontFamily : "var(--font-Source)", padding: 0, margin : 0 } }>Post { length - index - 1 }</h3>       
                
                <div style = { { flex : 1, paddingBottom : "48px", } }>
                    <h3 style = { { padding : 0, margin : 0, lineHeight : "140%", wordBreak: "break-word" } }>{ title }</h3>
                    { headingsString && (
                        <p style={{ marginTop: "16px", fontSize: "var(--font-size-small)", fontFamily: "var(--font-Source)", fontWeight: "400", color: "var(--grey)", lineHeight : "140%", wordBreak : "break-word" }}>{ headingsString }</p>
                    ) }
                </div>
            </div>
        </Link>
    )
}